import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import { BadgeType, License, Workbook } from 'types';
import { clickAwayOnlyUser } from 'components/App/util';
import { UserState } from 'state/modules/user';
import Config from '../../../config';

const { auditorAccessPrivilege, auditorAccessPrivilege2025 } = Config;

export const isTrialUser = (user: UserState) => !isClickAwayUser(user);

export const isClickAwayUser = (user: UserState | any): boolean =>
  user.clickAways?.length ? true : false;

export const getTrialDaysRemaining = (user: UserState, startDate: Date = new Date()): number => {
  const trialLicense = user.licenses.find(({ licenseTypeId }) => licenseTypeId === 6);
  return trialLicense
    ? differenceInCalendarDays(new Date(trialLicense.dateExpiration), startDate)
    : 0;
};

// TODO: This should be re-thought
export const getBadgeTypeForWorkbook = (
  licenses: Array<License>,
  clickAways: any[],
  workbook: Workbook
): BadgeType | any => {
  if (workbook?.products?.length > 0) {
    const license = licenses.find(
      license => license.productCurriculumId === workbook.products[0].productCurriculumId
    );
    const clickAway = clickAways.find(license =>
      workbook.products.find(y => y.productCurriculumId === license.productCurriculumId)
    );

    if (license && license.licenseTypeId === 6) {
      return 'freeTrial';
    }

    if (clickAway) {
      return 'clickAway';
    }

    return null;
  }

  if (clickAwayOnlyUser({ clickAways, licenses })) {
    return 'clickAway';
  }

  return null;
};

const getHasValidFullLicense = user => {
  const userLicenses = user.licenses?.map(license => {
    if (license.dateExpiration) {
      license.expired = new Date(license.dateExpiration) < new Date();
    } else {
      license.expired = false;
    }
    return license;
  });

  return !!userLicenses.length && userLicenses.some(x => !x.expired && x.licenseTypeId !== 6);
};

export const checkForAuditorUser = user => {
  const isAuditor = Object.values(user.organizations).some(({ organizationPrivileges }: any) =>
    organizationPrivileges.includes(auditorAccessPrivilege)
  );

  const hasValidFullLicense = getHasValidFullLicense(user);

  return isAuditor && !hasValidFullLicense;
};

export const checkFor2025AuditorUser = user => {
  if (!user) return false;
  return Object.values(user.me.organizations).some(({ organizationPrivileges }: any) =>
    organizationPrivileges.includes(auditorAccessPrivilege2025)
  );
};
